import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Constants } from '../shared/helpers/constants';

import { ApiService } from '../shared/services/api.service';
import { StorageService } from '../shared/services/storage.service';
import { CartService } from '../shared/services/cart.service';
import { SelfserviceService } from '../shared/services/selfservice.service';

import { Company } from '../shared/models/company';
import { Dmenu } from '../shared/models/dmenu';
import { Pcategory } from '../shared/models/pcategory';
import { Product } from '../shared/models/product';
import { ProductOrder } from '../shared/models/product-order';
import { Selfservice, SsOrder, SsOrderItem } from '../shared/models/selfservice';

import { StringHelpers } from '../shared/helpers/string-helpers';

import { environment } from '../../environments/environment';

import * as smoothscroll from 'smoothscroll-polyfill';
import { faArrowLeft, faCartShopping, faChevronDown, faChevronUp, faClipboardList, faUtensils } from '../icons';
@Component({
    selector: 'app-selfservice',
    templateUrl: './selfservice.component.html',
    styleUrls: ['./selfservice.component.scss'],
    standalone: false
})
export class SelfserviceComponent implements OnInit {
  faUtensils = faUtensils;
  faClipboardList = faClipboardList;
  faChevronUp = faChevronUp;
  faChevronDown = faChevronDown;
  faCartShopping = faCartShopping;
  faArrowLeft = faArrowLeft;

  company: Company;
  sscode: string;
  ss: Selfservice;
  dmenus: Dmenu[] = [];
  pcategories: Pcategory[];

  availableLangs: {
    abrev: string,
    flagUrl: string,
    selected: boolean,
    initial: boolean
  }[] = [{
    abrev: 'pt',
    flagUrl: '/assets/images/flags/flag-br.webp',
    selected: true,
    initial: true
  }];

  done = false;

  logoPath: string;
  serverUrl: string = environment.server_url;

  selectedDmenu: Dmenu;
  selectedProduct: Product;

  cartOpen: boolean = false;
  billOpen: boolean = false;

  pendingItems: SsOrderItem[] = [];

  // Guards against a double-tap on the cart's ENVIAR button firing two
  // place_order requests. _convertOrder() mints a fresh random `id` on each
  // call, so the backend's id-based dedup would NOT catch a double-send.
  sendingOrder: boolean = false;

  constructor(private route: ActivatedRoute,
    private api: ApiService,
    private storageServ: StorageService,
    private ssServ: SelfserviceService,
    public cart: CartService) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.logoPath = '/assets/companies-logo/' + params["company_name"] + ".webp";
      this.sscode = params["sscode"];

      this._loadCompany(params["company_name"]);
    });
  }

  selectLanguage(language: {abrev: string, flagUrl: string, selected: boolean, initial: boolean}) {
    for(let lang of this.availableLangs) {
      lang.selected = false;
      if(language.abrev == lang.abrev)
        lang.selected = true;
    }

    let abrev = language.initial ? null : language.abrev;

    Dmenu.translate(this.dmenus, abrev);
    Pcategory.translate(this.pcategories, abrev);
    if(this.pcategories) {
      for(let pcat of this.pcategories) {
        Product.translate(pcat.products, abrev);
      }
    }
    localStorage.setItem('preferred_lang', JSON.stringify(language));
  }
  loadPreferredLanguage() {
    let langStr = localStorage.getItem('preferred_lang');
    if(langStr) {
      this.selectLanguage(JSON.parse(langStr));
    }
  }

  togglePcategory(pcat: Pcategory) {
    pcat.user_hid = !pcat.user_hid;
    if(!pcat.products || pcat.products.length == 0) {
      this._loadProducts(pcat, true);
    }
  }

  selectProduct(product: Product) {
    this.selectedProduct = product;
  }
  addProduct(productOrder: ProductOrder) {
    this.cart.addItem(productOrder);
    this.selectedProduct = null;
  }

  navBack() {
    if(this.cartOpen) {
      this.cartOpen = false;
    } else if(this.billOpen) {
      this.billOpen = false;
    } else if(this.selectedProduct) {
      this.selectedProduct = null;
    } else if(this.selectedDmenu) {
      this.selectedDmenu = null;
    }
  }
  navCart() {
    if(!this.cartOpen && !this.selectedProduct) {
      this.cartOpen = true;
    }
  }
  navBill() {
    this.ssServ.reload().then(res => {
      this.ss = this.ssServ.ss;
      this.billOpen = true;
    }, err => {
      alert("Não foi possível acessar o consumo. Favor contatar atendente do estabelecimento")
    });
  }

  sendCart(ssOrder: SsOrder) {
    if(this.sendingOrder) {
      return;
    }
    this.sendingOrder = true;

    this.api.update('selfservices', `${this.sscode}/place_order`, {
      selfservice: {
        consumption: JSON.stringify(ssOrder)
      }
    }).subscribe(
      res => {
        this.sendingOrder = false;
        alert("Pedido Enviado!");
        this.cart.clear();
        this.cartOpen = false;
        this.cart.storeLocalOrder(ssOrder);
        this.ssServ.reload().then(res => {
          this.ss = this.ssServ.ss;
          this.pendingItems = Selfservice.getPendingItems(this.ss, this.cart.getLocalOrders());
        }, err => {
          alert("Erro ao carregar informações da comanda");
        });
      },
      err => {
        this.sendingOrder = false;

        let msg = "Erro ao enviar pedido! ";
        if(err.error && err.error.errors)
          msg += err.error.errors[0];

        alert(msg);
        console.log(err);
      }
    );
  }
  closeCart() {
    this.cartOpen = false;
  }
  closeBill() {
    this.billOpen = false;
  }

  // Loads company and dmenus
  private _loadCompany(name: string) {
    this.api.show('companies', name).subscribe(
      res => {
        this.company = res.company;
        Dmenu.setArrayAdditionalData(res.company.dmenus);
        this.dmenus = Dmenu.sortByDisplayOrder(res.company.dmenus, 'digital_menu', false);
        
        if(this.dmenus.length > 0) {
          // get translation info
          let langs = Dmenu.availableLangs(this.dmenus);
          for(let lang of langs) {
            this.availableLangs.push({
              abrev: lang,
              flagUrl: '/assets/images/flags/' + Constants.flagIcons[lang],
              selected: false,
              initial: false
            });
          }
          this.loadPreferredLanguage();

          this.done = true;

          this._loadPcategories();
          this._loadSelfservice();
        } else {
          alert("Não há Dmenus para esta empresa");
        }
      },
      err => {
        console.log(err);
        alert("Erro ao obter informações do restaurante");
      }
    );
  }
  // Loads all Dmenus's pcategories and preloads the products of their first two pcategories
  private _loadPcategories() {
    for(let dmenu of this.dmenus) {
      this.api.show('dmenus', dmenu.id).subscribe(
        res => {
          let pcats = res.dmenu.pcategories;
          dmenu.pcategories = [];
          for(let pcat of pcats) {
            if(pcat.hidden == false && pcat.digital_menu == true && Pcategory.checkSchedule(pcat) == 'open') {
              dmenu.pcategories.push(pcat);
            }
          }
          dmenu.pcategories = Pcategory.sortByDisplayOrder(dmenu.pcategories, 'digital_menu');
          for(let i = 0; i < Math.min(2, dmenu.pcategories.length); i++) {
            this._loadProducts(dmenu.pcategories[i], true);
          }
          for(let i = 2; i < dmenu.pcategories.length; i++) {
            dmenu.pcategories[i].user_hid = true;
          }
        },
        err => {
          console.log(err);
          alert("Erro ao carregar categorias do menu " + dmenu.name);
        }
      );
    }
  }

  private _loadProducts(pcategory: Pcategory, setOpen: boolean = false) {
    this.api.indexAll('products', {
      q: {
        pcategory_id: pcategory.id,
        hidden: false,
        digital_menu: true
      }
    }).subscribe(
      res => {
        Product.setArrayAdditionalData(res.products);
        pcategory.products = res.products;
        if(setOpen) {
          pcategory.user_hid = false;
        } else {
          pcategory.user_hid = true;
        }
      }
    );
  }

  // Run AFTER company is loaded
  private _loadSelfservice() {
    this.ssServ.init(this.sscode).then(selfservice => {
      if(!selfservice.valid) {
        alert("Erro: Cupom de autoatendimento não é válido!");
        return;
      }

      if(selfservice.company_id != this.company.id) {
        alert("Erro: Empresa não corresponde ao código de consumo");
        return;
      }

      this.ss = selfservice;
      this.pendingItems = Selfservice.getPendingItems(this.ss, this.cart.getLocalOrders());
    }).catch(err => {
      console.log(err);
      alert("Código não é válido");
    });
  }
}
